// extracted by mini-css-extract-plugin
export default {"container":"NotToday_container__k0+he","title":"NotToday_title__taoyT"};